<ng-container *ngFor="let alert of alerts">
  <div class="{{ cssClass(alert) }} ">
    <span [innerHTML]="alert.message"></span>
    <a class="close" (click)="removeAlert(alert)">&times;</a>
  </div>
</ng-container>
